var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconContacts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .contacts-class-a {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n\n            .contacts-class-b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "contacts-class-a",
    d: "M95,231.833A1.833,1.833,0,0,0,93.167,230h-16.5a1.833,1.833,0,0,0-1.833,1.833v6.417H73.458a.459.459,0,0,0,0,.917h1.375v1.375H73.458a.458.458,0,1,0,0,.916h1.375v1.375H73.458a.459.459,0,0,0,0,.917h1.375v6.417A1.833,1.833,0,0,0,76.667,252h16.5A1.833,1.833,0,0,0,95,250.167ZM76.667,243.75v6.417h3.667V231.833H76.667v6.417h1.375a.459.459,0,0,1,0,.917H76.667v1.375h1.375a.458.458,0,1,1,0,.916H76.667v1.375h1.375a.459.459,0,0,1,0,.917Zm16.5,6.417H81.25V231.833H93.167Z",
    transform: "translate(-68.5 -224.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "contacts-class-b",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconContacts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_contacts.ddca415264afba8a9c65a5801ade5590.svg";